import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { IconCalendarTime } from '@calendly/ui/components/glyphs/IconCalendarTime'
import { useMainContainerSize } from '@calendly/ui/hooks/main-container-size-context'
import { forwardRef } from 'react'

/**
 * Header action that opens Available hours. Forwards a ref so the Scheduling
 * onboarding spotlight can highlight this control when the global beta FF is on.
 */
export const ManageAvailabilityButton = forwardRef(({ onClick }, ref) => {
  const { isLargeMainContainer } = useMainContainerSize()
  const buttonSize = isLargeMainContainer ? 'medium' : 'small'

  return (
    <Button
      ref={ref}
      appearance="secondary-outline"
      size={buttonSize}
      leadingIcon={IconCalendarTime}
      onClick={onClick}
      data-testid="manage-availability-button"
    >
      {I18n.t('publisher.home.scheduling_subsection.manage_availability_button')}
    </Button>
  )
})
